"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M10.3115 2.063C10.3575 2.078 10.4005 2.093 10.4435 2.115C10.4795 2.133 10.5135 2.153 10.5475 2.176C10.5645 2.187 10.5835 2.188 10.5995 2.2L14.5995 5.2C14.8625 5.396 14.9995 5.697 14.9995 6.001C14.9995 6.209 14.9345 6.42 14.7995 6.6C14.4685 7.042 13.8415 7.131 13.4005 6.8L11.3995 5.299C11.2345 5.176 10.9995 5.293 10.9995 5.5V13C10.9995 13.552 10.5525 14 9.9995 14C9.4475 14 8.9995 13.552 8.9995 13V5.5C8.9995 5.293 8.7645 5.176 8.6005 5.299L6.5995 6.8C6.1585 7.131 5.5315 7.042 5.2005 6.6C4.8695 6.157 4.9575 5.531 5.4005 5.2L9.4005 2.2C9.4155 2.188 9.4355 2.187 9.4515 2.176C9.4865 2.153 9.5195 2.133 9.5565 2.115C9.5995 2.093 9.6425 2.078 9.6875 2.063C9.7295 2.049 9.7685 2.035 9.8105 2.026C9.8515 2.019 9.8905 2.017 9.9325 2.014C9.9565 2.012 9.9765 2 9.9995 2C10.0235 2 10.0435 2.012 10.0675 2.014C10.1085 2.017 10.1485 2.019 10.1895 2.026C10.2315 2.035 10.2705 2.049 10.3115 2.063ZM14.5 18H5.5C5.224 18 5 17.776 5 17.5V16.5C5 16.224 5.224 16 5.5 16H14.5C14.776 16 15 16.224 15 16.5V17.5C15 17.776 14.776 18 14.5 18Z",
    fill: "#727B7F"
  }));
};